import { render, staticRenderFns } from "./BookingApplicant.vue?vue&type=template&id=edabae48&scoped=true&"
import script from "./BookingApplicant.vue?vue&type=script&lang=js&"
export * from "./BookingApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edabae48",
  null
  
)

export default component.exports